import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import Sticky from "Components/Sticky";
import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "Icons/back.svg";
import { ReactComponent as UploadIcon } from "Icons/upload-blue.svg";
import {ReactComponent as DeleteIcon} from 'Icons/delete.svg';
import {ReactComponent as PlusIcon} from 'Icons/plus.svg';
import Button from "Components/Button";
import Checkbox from "Components/Checkbox";
import Dropdown from "Components/Dropdown";
import { SingleDatePicker } from "react-dates";
import TimePicker from 'rc-time-picker';
import classNames from "classnames";
import Moment from 'moment';
import Upload from "Components/Upload";
import Cx from "classnames";
import TransportersCard from 'Components/TransportersCard';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import Preview from 'Icons/rfqSingleMode.png';
import { transformRfq } from 'Utils/transform';
import { 
    GET_RFQ_EVENT,
    GET_VEHICLE_TYPES,
    GET_VEHICLE_BODY_TYPES,
    GET_BUSINESS_VOLUMES,
    GET_EVENT_RFQ_TRIPS,
    GET_PRICING_BASIS,
    GET_GROUPS_AND_TRANSPORTERS,
    UPDATE_EVENT_RFQ,
    UPDATE_EVENT_RFQ_TRIPS,
    TOAST_ERROR
} from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
import ActionLoader from "Components/ActionLoader/index";
import { Table } from "reactstrap";
import { TAT_UNITS } from 'Constants/commonConstants';

class EditEvent extends Component {
    constructor(props) {
        super(props);
        this.rfq = props.rfq;
        this.state = {
            rfq: this.rfq,
            trips: [],
            transporterIds: [],
            isTripEdited: false
        }
    }

    componentDidMount() {
        // this.getEvent();
        this.getTrips();
        this.getConstansValues();
        this.searchGroupsAndTransporters();
    }

    componentWillReceiveProps(nextProps, props) {
      if((nextProps.selectedNavBranch || {}).branch_id && ((nextProps.selectedNavBranch || {}).branch_id !== (this.props.selectedNavBranch || {}).branch_id)) {
         this.getConstansValues((nextProps.selectedNavBranch || {}).branch_id);
      }
   }

   getTrips = () => {
    const { dispatch, match } = this.props;
    dispatch({
        type: GET_EVENT_RFQ_TRIPS,
        params: {
            rfqId: (match.params || {}).rfqId
        },
        onSuccess: (data) => {
            this.setState({
                trips: data.list || [],
                transporterIds: JSON.parse(JSON.stringify(((data.rfq || {}).transporters || {}).transporter_ids || [])),
                rfq: transformRfq(data.rfq  || {}),
                isTripEdited: false
            });
        }
    })
   }

    getEvent = () => {
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_RFQ_EVENT,
            params: {
                eventId: (match.params || {}).eventId,
                rfqType: 1,
                rfqId: (match.params || {}).rfqId
            },
            onSuccess: (data) => {
                this.setState({
                    rfq: data
                })
            }
        })
    }

    goBack = () => {
      const { history, match } = this.props;
        location.href = `/preview/${match.params.eventId}/${match.params.parentId}`;
    };

    getConstansValues = (branchId = '') => {
        const { dispatch } = this.props;
        const user = getUser();
        const params = {
            rfqType: 1,
            companyId: user.companyId,
            branchId: branchId ? branchId : user.branchId
        }
        dispatch({
            type: GET_PRICING_BASIS,
            data: params
        });
        dispatch({ 
            type: GET_VEHICLE_TYPES, 
            params 
        });
        dispatch({
            type: GET_VEHICLE_BODY_TYPES,
            params
        });
        dispatch({ 
            type: GET_BUSINESS_VOLUMES, 
            data: params 
        });
    }

    searchGroupsAndTransporters = (search, type = 2, isMultimode, isWarehouse, movementType) => {
        const { dispatch, match } = this.props;
        const branchLocalName = localStorage.getItem('branchDetail');
        const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
        dispatch({
            type: GET_GROUPS_AND_TRANSPORTERS,
            params: {
                search,
                branchId: name.branch_id,
                type,
                isMultimode: isMultimode || undefined,
                isWarehouse: ((match.params || {}).type === 7) && true || isWarehouse || undefined,
                rfqType: 1,
                movementType: movementType || undefined
            }
        })
    }

    setvehicleDetails = (option, index, type) => {
        const { trips } = this.state;
        if(type === 'vehicle') {
            trips[index].vehicle_details['vehicle_type'] = option.value;
            trips[index].vehicle_details['vehicle_type_name'] = option.name;
        } else {
            trips[index].vehicle_details['vehicle_body_type'] = option.value;
            trips[index].vehicle_details['vehicle_body_type_name'] = option.name;
        }
        this.setState({
            trips,
            isTripEdited: true
        });
    }

    onChangeStops = (e, label, stopIndex, index) => {
        const { trips } = this.state;
        trips[index].stops[stopIndex][label] = e.target.value;
        this.setState({
            trips,
            isTripEdited: true
        })
    }

    onChangeTAT = (value, index, vType) => {
        const { trips } = this.state;
        if(vType) {
            trips[index].bidding_and_payments['tat'].value = value.target.value;
        } else {
            trips[index].bidding_and_payments['tat'].unit =  value.value;
            trips[index].bidding_and_payments['tat'].name = value.name;
        }
        this.setState({
            trips,
            isTripEdited: true
        })
    }

    onChangeBV = (value, index, vType) => {
        const { trips } = this.state;
        if(vType) {
            trips[index].bidding_and_payments['business_volume'].value = value.target.value;
        } else {
            trips[index].bidding_and_payments['business_volume'].unit =  value.value;
            trips[index].bidding_and_payments['business_volume'].name = value.name;
        }
        this.setState({
            trips,
            isTripEdited: true
        })
    }

    onChangePricingBasis = (option, index) => {
        const { trips } = this.state;
        trips[index].bidding_and_payments.pricing_basis = option.value;
        trips[index].bidding_and_payments.pricing_basis_name = option.name;
        this.setState({
            trips,
            isTripEdited: true
        })
    }

    onChangeQbr = (e, index) => {
        const { trips } = this.state;
        trips[index].bidding_and_payments.qbr = e.target.value;;
        this.setState({
            trips,
            isTripEdited: true
        })
    }

    addTrip = () => {
        const { trips, rfq } = this.state;
        const tripObj = {
            bidding_and_payments: {
                business_volume: {
                    unit: '',
                    value: '',
                    name: ''
                },
                tat: {
                    unit: 1,
                    name: 'Days',
                }
            },
            stops: [{
                location: '',
                address: '',
                city: '',
                state: '',
                type: 1,
                sequence: 1
            }, {
                location: '',
                address: '',
                city: '',
                state: '',
                type: 2,
                sequence: 2
            }],
            vehicle_details: {},
            rfq_id: rfq.id,
            rfq_name: rfq.rfq_name
        }
        trips.push(tripObj);
        this.setState({
            trips,
            isTripEdited: true
        })
    }

    onDeleteTrip = (index) => {
        const { trips } = this.state;
        trips.splice(index, 1);
        this.setState({
            trips,
            isTripEdited: true
        })
    }  
    
    onSaveEvent = (type) => {
        const { dispatch, match, history } = this.props;
        const { rfq, transporterIds, trips, isTripEdited, isTransporterEdited } = this.state;
        const rfqData = rfq.getApiData();
        // const transportersList  = ((rfqData.docs_and_transporters.transporters || {}).transporter_ids || []).filter(trans => !transporterIds.includes(trans));
        if(isTransporterEdited) {
            dispatch({
                type: UPDATE_EVENT_RFQ,
                data: {
                    rfq_id: rfqData.rfq_id,
                    transporters: rfqData.docs_and_transporters.transporters
                },
                onSuccess: () => {
                    if(type === 1) {
                        this.setState({
                            isTransporterEdited: false
                        });
                    } else if(!isTripEdited) {
                        history.push(`/preview/${rfqData.event_id}/${match.params.parentId}`);
                    }
                }
            })
        }
        if(isTripEdited) {
            let isValid = true;
            (trips || []).forEach((trip) => {
                if(!((trip.stops[0] || {}).location && (trip.stops[0] || {}).state && (trip.stops[1] || {}).location && (trip.stops[1] || {}).state && (trip.vehicle_details || {}).vehicle_type && (trip.vehicle_details || {}).vehicle_body_type && (((rfqData.rfq_details || {}).bidding_details || {}).is_accept_partial_solution ? true : (((trip.bidding_and_payments || {}).business_volume || {}).value && ((trip.bidding_and_payments || {}).business_volume || {}).unit)) && (trip.bidding_and_payments || {}).pricing_basis)) {
                    isValid = false;
                }
            });
            if(!isValid) {
                dispatch({
                    type: TOAST_ERROR,
                    message: 'Please Enter all mandatory fields'
                });
                this.setState({
                    isTripEdited: false
                });
                return;
            }
            dispatch({
                type: UPDATE_EVENT_RFQ_TRIPS,
                data: {
                    trips: trips,
                    rfq_id: rfqData.rfq_id,
                    event_id: rfqData.event_id
                },
                onSuccess: () => {
                    if(type === 1) {
                        this.getTrips();
                    } else {
                        history.push(`/preview/${rfqData.event_id}/${match.params.parentId}`);
                    }
                }
            })
        }
        if(type === 2 && !isTripEdited && !isTransporterEdited) {
            history.push(`/preview/${rfqData.event_id}/${match.params.parentId}`);
        }
    }

  render() {
    const { rfq, trips } = this.state;
    const { transporters, groups, vehicleTypes, loader, vehicleBodyTypes, pricingBasis, businessVolumes, match } = this.props;

    return (
     <div style={{ backgroundColor: "#e3e9ff"}}>
      {loader && <ActionLoader fixed={true} />}
      <Sticky>
        <section className=" pr-20 pl-20 pt-25 event-management col-1">
          <section className="trip-title-container flex flex-between mb-10">
            <div className="flex flex-middle flex-1 curP">
                <Link
                  className="flex flex-middle wt-max-content theme-color fs-22 mr-20"
                  to={`/preview/${match.params.eventId}/${match.params.parentId}`}
                >
                <BackIcon className="mr-10 fill-theme curP fBold" />
                Back
              </Link>
             { rfq && rfq.event_id && 
              <span className="fBold header-text fs-24">{rfq.rfq_name}</span>
             }
            </div>
          </section>
          {rfq && rfq.event_id &&
          <section className="mb-20  pl-20 pr-20 pt-20 pb-20 br-5 border-1px-regent-gray">
            <header className="fBolder fs-18 mb-10 header-text">
              Transporters
            </header>
            {groups.length > 0 && <TransportersCard
              searchGroupsAndTransporters={this.searchGroupsAndTransporters}
              transporters={transporters || []}
              rfq={rfq}
              groups={groups || []}
              setGroups={(data) => {
                rfq.setGroups(data);
                this.setState({
                    isTransporterEdited: true
                })
              }}
          />}
          </section>}
            <section className="overflowAuto col-1 status-table-height">
              <Table striped className="upload-rfq-table col-1 fs-18 mb-80" responsive bordered>
              <thead>
                    <tr>
                    <th className="upload-td-th upload-th fixed-column"></th>
                      <th className="upload-td-th upload-th">SRC_LOC<span className="fs-24 error-color fBold ml-5">*</span></th>
                      <th className="upload-td-th upload-th">SRC_ADDRESS</th>
                      <th className="upload-td-th upload-th">SRC_REMARKS</th>
                      <th className="upload-td-th upload-th">SRC_CITY</th>
                      <th className="upload-td-th upload-th">SRC_STATE<span className="fs-24 error-color fBold ml-5">*</span></th>
                      <th className="upload-td-th upload-th">DEST_LOC<span className="fs-24 error-color fBold ml-5">*</span></th>
                      <th className="upload-td-th upload-th">DEST_ADDRESS</th>
                      <th className="upload-td-th upload-th">DEST_REMARKS</th>
                      <th className="upload-td-th upload-th">DEST_CITY</th>
                      <th className="upload-td-th upload-th">DEST_STATE<span className="fs-24 error-color fBold ml-5">*</span></th>
                      <th className="upload-td-th upload-th">VEHICLE TYPE<span className="fs-24 error-color fBold ml-5">*</span></th>
                      <th className="upload-td-th upload-th">BODY TYPE<span className="fs-24 error-color fBold ml-5">*</span></th>
                      <th className="upload-td-th upload-th">TAT</th>
                      <th className="upload-td-th upload-th">DAYS</th>
                      <th className="upload-td-th upload-th">VOLUME{(rfq && !rfq.rfqDetails.acceptPartialSolution) && <span className="fs-24 error-color fBold ml-5">*</span>}</th>
                      <th className="upload-td-th upload-th">UOM {(rfq && !rfq.rfqDetails.acceptPartialSolution) && <span className="fs-24 error-color fBold ml-5">*</span>}</th>
                      <th className="upload-td-th upload-th">PRICING_BASIS<span className="fs-24 error-color fBold ml-5">*</span></th>
                      <th className="upload-td-th upload-th">QBR</th>
                      <th className="upload-td-th upload-th">PLACEMENT_DATE</th>
                      <th className="upload-td-th upload-th">PLACEMENT_TIME</th>
                    </tr>
                </thead>
                <tbody>
                    {(trips || []).map((trip, tripIndex) => {
                    return(<tr>
                        <td className="upload-td-th data-column fixed-column">
                            <div className="flex flex-center">
                                <DeleteIcon className="wt-20 ht-20 curP" onClick={() => this.onDeleteTrip(tripIndex)}/>
                                {(tripIndex === trips.length - 1) && <PlusIcon className="wt-20 ht-20 ml-10 edit-event-add curP" onClick={this.addTrip}/>}
                            </div>
                        </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="Location"
                            value={(trip.stops[0] || {}).location}
                            onChange={(e) => this.onChangeStops(e, 'location', 0, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="Address"
                            value={(trip.stops[0] || {}).address}
                            onChange={(e) => this.onChangeStops(e, 'address', 0, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="Remarks"
                            value={(trip.stops[0] || {}).remarks}
                            onChange={(e) => this.onChangeStops(e, 'remarks', 0, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="City"
                            value={(trip.stops[0] || {}).city}
                            onChange={(e) => this.onChangeStops(e, 'city', 0, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="State"
                            value={(trip.stops[0] || {}).state}
                            onChange={(e) => this.onChangeStops(e, 'state', 0, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="Location"
                            value={(trip.stops[1] || {}).location}
                            onChange={(e) => this.onChangeStops(e, 'location', 1, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="Address"
                            value={(trip.stops[1] || {}).address}
                            onChange={(e) => this.onChangeStops(e, 'address', 1, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="Remarks"
                            value={(trip.stops[1] || {}).remarks}
                            onChange={(e) => this.onChangeStops(e, 'remarks', 1, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="City" 
                            value={(trip.stops[1] || {}).city}
                            onChange={(e) => this.onChangeStops(e, 'city', 1, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                        <input 
                            className="border-bottom-light fs-16 tCenter"
                            placeholder="State"
                            value={(trip.stops[1] || {}).state}
                            onChange={(e) => this.onChangeStops(e, 'state', 1, tripIndex)}
                        />
                      </td>
                      <td className="upload-td-th">
                            <Dropdown
                                items={vehicleTypes}
                                className={Cx('event-select wt-200 br-5')}
                                label="Select..."
                                displayKey="name"
                                selectedItem={vehicleTypes.find(vehicleType => vehicleType.value === (trip.vehicle_details || {}).vehicle_type)}
                                onSelect={(option) => this.setvehicleDetails(option, tripIndex, 'vehicle')}
                            />
                      </td>
                      <td className="upload-td-th">
                            <Dropdown
                                items={vehicleBodyTypes}
                                className={Cx('event-select wt-200 br-5')}
                                label="Select..."
                                displayKey="name"
                                selectedItem={vehicleBodyTypes.find(vehicleBodyType => vehicleBodyType.value === (trip.vehicle_details || {}).vehicle_body_type)}
                                onSelect={(option) => this.setvehicleDetails(option, tripIndex, 'vehicleBodyType')}
                            />
                      </td>
                      <td className="upload-td-th">
                            <input 
                                className="border-bottom-light fs-16 tCenter"
                                placeholder="TAT"
                                type="number"
                                value={((trip.bidding_and_payments || {}).tat || {}).value}
                                onChange={(e) => this.onChangeTAT(e, tripIndex, true)}
                            />
                      </td>
                      <td className="upload-td-th">
                            <Dropdown
                                items={TAT_UNITS}
                                className={Cx('event-select wt-200 br-5')}
                                label="Select..."
                                displayKey="name"
                                selectedItem={TAT_UNITS.find(tatUnit => tatUnit.value === ((trip.bidding_and_payments || {}).tat || {}).unit)}
                                onSelect={(e) => this.onChangeTAT(e, tripIndex)}
                            />
                      </td>
                      <td className="upload-td-th">
                            <input 
                                className="border-bottom-light fs-16 tCenter"
                                placeholder="Volume"
                                type="number"
                                value={((trip.bidding_and_payments || {}).business_volume || {}).value}
                                onChange={(e) => this.onChangeBV(e, tripIndex, true)}
                            />
                      </td>
                      <td className="upload-td-th">
                            <Dropdown
                                items={businessVolumes}
                                className={Cx('event-select wt-200 br-5')}
                                label="Select..."
                                displayKey="name"
                                selectedItem={businessVolumes.find(bv => bv.value === ((trip.bidding_and_payments || {}).business_volume || {}).unit)}
                                onSelect={(e) => this.onChangeBV(e, tripIndex)}
                            />
                      </td>
                      <td className="upload-td-th">
                            <Dropdown
                                items={pricingBasis}
                                className={Cx('event-select wt-200 br-5')}
                                label="Select..."
                                displayKey="name"
                                selectedItem={pricingBasis.find(pb => pb.value === (trip.bidding_and_payments || {}).pricing_basis)}
                                onSelect={(option) => this.onChangePricingBasis(option, tripIndex)}
                            />
                      </td>
                      <td className="upload-td-th">
                            <input
                                placeholder="qbr"
                                className="border-bottom-light fs-16 tCenter"
                                type="number"
                                value={(trip.bidding_and_payments || {}).qbr}
                                onChange={(e) => this.onChangeQbr(e, tripIndex)} 
                            />
                      </td>
                      <td className="upload-td-th">
                            <SingleDatePicker
                                    noBorder={true}
                                    displayFormat={"DD MMM YYYY"}
                                    hideKeyboardShortcutsPanel={true}
                                    placeholder={"Placement Date"}
                                    numberOfMonths={2}
                                    date={(trip.vehicle_details || {}).placement_time &&  Moment((trip.vehicle_details || {}).placement_time) || null} 
                                    onDateChange={(from) =>{
                                        if(from) {
                                            const { trips } = this.state;
                                            const date = from.format('YYYY-MM-DD') + ' ' + Moment((trips[tripIndex].vehicle_details || {}).placement_time || from).format('HH:mm');
                                            (trips[tripIndex].vehicle_details || {}).placement_time = new Date(date).getTime();
                                            this.setState({
                                                trips,
                                                isTripEdited: true
                                            })
                                        }
                                    }}
                                    focused={this.state[`focusedStart${tripIndex}`]} 
                                    onFocusChange={({ focused }) => this.setState({ [`focusedStart${tripIndex}`]: focused })} 
                                    // isOutsideRange={(date) => date < new Date(systemTime).setHours(0)}
                                />
                      </td>
                      <td className="upload-td-th">
                            <TimePicker
                                showSecond={false}
                                value={(trip.vehicle_details || {}).placement_time && Moment((trip.vehicle_details || {}).placement_time) || null}
                                className="ht-40 wt-150 border-status-bar br-5"
                                onChange={(from) =>{
                                    const { trips } = this.state;
                                    const date = Moment((trips[tripIndex].vehicle_details || {}).placement_time).format('YYYY-MM-DD') + ' ' + from.format('HH:mm');
                                    (trips[tripIndex].vehicle_details || {}).placement_time = new Date(date).getTime();
                                    this.setState({
                                        trips,
                                        isTripEdited: true
                                    })
                                }}
                                // minTime={new Date()}
                                // minTime={Moment(systemTime)}
                                placeholder={'Time'}
                                format={'h:mm a'}
                                use12Hours
                                inputReadOnly
                                // disabled={this.viewMode || this.viewType===TRIP_TYPE}
                            />
                      </td>
                    </tr>)})}
                </tbody>
              </Table>
            </section>
      
          <section className=" mb-20   pl-20 pr-20 pt-20 pb-20 br-5 ">
            {this.props.isPreview ? 
            <div className="wt-150 ml-25 mt-50 fRight mb-50">
                <Button className="button-classic" value="Schedule" onClick={this.onScheduleEvent} />
            </div>
            :
                <div className="wt-150 ml-25 mt-50 fRight mb-50">
                    <Button className={Cx("button-classic", {
                    // 'disabled': this.validateData()
                    })} value="Next" onClick={() => this.onSaveEvent(2)} />
                </div>}
                <div className="wt-150 ml-25 mt-50 fRight mb-50">
                <Button className="button-classic" value="Save" onClick={() => this.onSaveEvent(1)} />
                </div>
                <div className="wt-150 ml-25 mt-50 fRight mb-50">
                <Button className="button-classic " value="Previous" onClick={this.goBack} />
                </div>
          </section>
          </section>
      </Sticky></div>
    );
  }
}

const mapStateToProps = ({ constants, rfq, contracting }) => {
    return {
      transporters: constants.transporters || [],
      groups: constants.groups || [],
      rfq: rfq.createdRFQ || null,
      vehicleTypes: constants.vehicleTypes || [],
      vehicleBodyTypes: constants.vehicleBodyTypes || [],
      businessVolumes: constants.businessVolumes || [],
      pricingBasis: constants.pricingBasis || [],
      loader: contracting.loader || false,
      selectedNavBranch: constants.selectedNavBranch || {},
    }
}
export default connect(mapStateToProps)(EditEvent);